export default {"src":"/_next/static/media/big logo.3d1411f2.svg","height":106,"width":266,"blurWidth":0,"blurHeight":0};